@if (items().length > 1) {
    <div class="breadcrumb-container">
        <p-breadcrumb [model]="items()" [home]="home" />
    </div>
}
